export const theme = {
  global: {
    colors: {
      brand: "#4051b5",
    },
    font: {
      family:
        '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      size: "14px",
    },
  },
  heading: {
    responsiveBreakpoint: undefined,
    extend: (props: any): string => {
      return `
      letter-spacing: -.5px;

      ${props.level === 2 && `font-weight: 600;`}
    `;
    },
    weight: 700,
    level: {
      1: {
        medium: {
          size: "20px",
          height: "30px",
        },
      },
      2: {
        medium: {
          size: "15px",
          height: "20px",
        },
      },
    },
  },
  text: {
    small: {
      size: "12px",
      height: "16px",
    },
    medium: {
      size: "13px",
      height: "21px",
    },
  },
  anchor: {
    color: { dark: "brand", light: "brand" },
  },
  button: {
    hover: {
      default: {
        background: {
          color: "#eeeeee",
        },
      },
      primary: {
        background: {
          color: "#626eb3",
        },
      },
    },
    default: {
      color: "#333333",
      font: {
        weight: 600,
      },
      background: {
        color: "#f3f3f3",
      },
      extend: `
        height: 30px;
        padding: 0 14px 1px;
      `,
    },
    primary: {
      color: "#ffffff",
      font: {
        weight: 600,
      },
      background: {
        color: "brand",
      },
    },
  },
};
